import React, { useEffect, useState } from "react";
// styled components
import { Row, Col, Image } from "antd";
// images
import Imageconvocatoria from "../../../assets/landing/LogoConvocatoriaGeneric.PNG";
import { Convocatoria } from "../../../models/ConvocatoriasModel/convocatoria.model";
import apiConvocatorias from "../../../api/Convocatorias/api-convocatorias";
import apiMaestras from "../../../api/Maestras/api-maestras";
import { useEncrypt } from "../../../hooks/useEncrypt";
import moment from "moment";

// models
interface IProps {
  BannerText: string
  convocatorias: Convocatoria
}

export const BannerJurados: React.FC<IProps> = (props: IProps) => {

  const [LineasConvocatorias, setLineasConvocatorias] = useState([]);

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria: number) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) return valueFilter[0].nombre;
  }
  const [convocatoria, setconvocatoria] = useState({
    area: [],
    fechas: [],
    linea_estrategica: null,
    nombre_convocatoria: null,
    entidad: null,
  });

  const { decrypt } = useEncrypt();
  const idConvocatoria = decrypt(localStorage.getItem("idConvocatoriaPostulacion"));
  
  useEffect(() => {
    consultarConvocatoria();
    getLineasConvocatorias();
  }, []);

  const consultarConvocatoria = async () => {
    const { data } = await apiConvocatorias.infoBannerPostulacionConvocatoria(
      idConvocatoria
    );
    return setconvocatoria(data);
  };

  return (
    <div className="container-background-jurados">
      <div className="subcontainer-background-participantes">
        <div className="container-fluid2">
          <div className="row">
            <div className="col-4 col-md-2 me-md-4 mt-5 mb-md-5">
              <Image src={Imageconvocatoria} preview={false} />
            </div>
            <div className="col-12 col-md-9 mt-5 mb-5">
              <div className="row">
                <div
                  style={{ lineHeight: "normal", paddingBottom: "2px" }}
                  className="col-12 font-family-Montserrat-Bold font-size-15px font-color-FFFFFF subtexto-sombras-general"
                >
                  Formulario de Postulación
                </div>
                <div
                  style={{ lineHeight: "normal", paddingBottom: "2px" }}
                  className="col-12 font-family-Montserrat-Bold font-size-22px font-color-FFFFFF texto-sombras-general"
                >
                  {convocatoria?.nombre_convocatoria}
                </div>
                <div
                  style={{ lineHeight: "normal", paddingBottom: "16px" }}
                  className="col-12 font-size-15px font-color-FFFFFF subtexto-sombras-general"
                >
                  {getFilterLineaConvocatoria(props.convocatorias.linea_convocatoria) !== undefined ? `${getFilterLineaConvocatoria(props.convocatorias.linea_convocatoria)}` : ""}
                </div>
                <div className="col-12 col-md-4 mt-2 font-family-Montserrat-Regular font-size-12px font-color-FFFFFF">
                  <span className="no-margin font-family-Montserrat-Bold">
                    ENTIDAD:
                  </span>{" "}
                  {convocatoria.entidad !== null
                    ? convocatoria.entidad
                    : "No tiene entidad"}
                </div>
                <div className="col-12 col-md-4 mt-2 font-family-Montserrat-Regular font-size-12px font-color-FFFFFF">
                  <span className="no-margin font-family-Montserrat-Bold">
                    LÍNEA ESTRATÉGICA:
                  </span>{" "}
                  {convocatoria.linea_estrategica !== null
                    ? convocatoria.linea_estrategica
                    : "No tiene línea estratégica"}
                </div>
                <div className="col-12 col-md-4 mt-2 font-family-Montserrat-Regular font-size-12px font-color-FFFFFF">
                  <span className="no-margin font-family-Montserrat-Bold">
                    FECHA INICIO:
                  </span>{" "}
                  {convocatoria?.fechas !== null &&
                    convocatoria?.fechas?.length > 0
                    ? convocatoria?.fechas?.filter(
                      (data) => data.clave === "Apertura"
                    )?.length > 0
                      ? `${moment(
                        convocatoria.fechas
                          .filter((data) => data.clave === "Apertura")[0]
                          .valormin.substring(0, 10)
                      ).format("LL")} ${moment(convocatoria.fechas
                        .filter((data) => data.clave === "Apertura")[0].valormax).isValid() && moment(convocatoria.fechas.filter((data) => data.clave === "Apertura")[0].valormax).format("L") !== moment(convocatoria.fechas.filter((data) => data.clave === "Apertura")[0].valormin).format("L") ? `al ${moment(convocatoria.fechas.filter((data) => data.clave === "Apertura")[0].valormax.substring(0, 10)).format("LL")}` : ""}`
                      : null
                    : null}
                </div>
                <div className="col-12 col-md-4 mt-2 font-family-Montserrat-Regular font-size-12px font-color-FFFFFF">
                  <span className="no-margin font-family-Montserrat-Bold">
                    FECHA CIERRE:
                  </span>{" "}
                  {convocatoria.fechas !== null &&
                    convocatoria.fechas.length > 0
                    ? convocatoria.fechas.filter(
                      (data) => data.clave === "Cierre"
                    ).length > 0
                      ? `${moment(
                        convocatoria.fechas
                          .filter((data) => data.clave === "Cierre")[0]
                          .valormin.substring(0, 10)
                      ).format("LL")} ${moment(convocatoria.fechas
                        .filter((data) => data.clave === "Cierre")[0].valormax).isValid() && moment(convocatoria.fechas.filter((data) => data.clave === "Cierre")[0].valormax).format("L") !== moment(convocatoria.fechas.filter((data) => data.clave === "Cierre")[0].valormin).format("L") ? `al ${moment(convocatoria.fechas.filter((data) => data.clave === "Cierre")[0].valormax.substring(0, 10)).format("LL")}` : ""}`
                      : null
                    : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
